import BreakdownByResidenceStatus from './BreakdownByResidenceStatus';

export default BreakdownByResidenceStatus;
